import { Modal, Row, Col, Button } from "antd";
import React from "react";

const ArchiveConfirmModal = ({
  visible,
  setVisible,
  mode = "archive", // 'archive' | 'unarchive'
  text = "Profile",
  onConfirm,
  loading,
}) => {
  const isArchive = mode === "archive";
  const title = `${isArchive ? "Archive" : "Unarchive"} ${text}?`;
  const description = isArchive
    ? `Are you sure you want to archive the selected ${text.toLowerCase()}?`
    : `Are you sure you want to unarchive the selected ${text.toLowerCase()}?`;
  const actionLabel = isArchive ? "Archive" : "Unarchive";

  return (
    <Modal
      className="candidateDeleteModal"
      centered
      width={392}
      getContainer={document.body}
      onCancel={() => setVisible(false)}
      open={visible}
      footer={null}
      title={title}
    >
      <Row className="header">
        <Col>
          <p className="desc">{description}</p>
        </Col>
      </Row>

      <Row align="middle" gutter={16} justify="end">
        <Col>
          <Button className="confirmBtn" onClick={onConfirm} loading={loading}>
            {actionLabel}
          </Button>
        </Col>
        <Col>
          <Button className="cancelBtn" onClick={() => setVisible(false)}>
            Cancel
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default ArchiveConfirmModal; 